import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { Footer } from "./Footer";
import { COMPANY } from "./data";
import { Impressum, Datenschutz } from "./LegalTexts";
import { useSeo } from "@/seo/useSeo";
import shared from "@/seo/shared";

const META = {
  impressum: { title: "Impressum", doc: "Impressum | Christian Bedachungen – Dachdecker Schifferstadt" },
  datenschutz: { title: "Datenschutzerklärung", doc: "Datenschutzerklärung | Christian Bedachungen – Dachdecker Schifferstadt" },
};

export default function LegalPage({ type, onCookies }) {
  const meta = META[type];
  const seo = shared.EXTRA.find((p) => p.path === `/${type}`);
  useSeo({ path: seo.path, title: seo.title, description: seo.description, ld: shared.businessLd() });

  useEffect(() => {
    document.title = meta.doc;
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
    return () => {
      document.title = "Dachdecker Schifferstadt | Christian Bedachungen – Meisterbetrieb seit 2008";
    };
  }, [meta.doc]);

  return (
    <>
      <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-ink/90 py-3 backdrop-blur-xl">
        <div className="mx-auto flex max-w-[1440px] items-center justify-between gap-4 px-5 sm:px-8 lg:px-12">
          <Link to="/" className="group" aria-label="Zur Startseite" data-testid="legal-logo"><Logo /></Link>
          <div className="flex items-center gap-3">
            <a href={COMPANY.phoneHref} className="btn-primary hidden !px-5 !py-3 sm:inline-flex" data-testid="legal-phone"><Phone size={16} /> {COMPANY.phoneDisplay}</a>
            <Link to="/" className="btn-ghost !px-4 !py-3" data-testid="legal-back"><ArrowLeft size={16} /> <span className="hidden sm:inline">Zur Startseite</span><span className="sm:hidden">Zurück</span></Link>
          </div>
        </div>
      </header>
      <main className="bg-paper pb-24 pt-32 text-ink sm:pb-32 sm:pt-40" data-testid={`legal-page-${type}`}>
        <article className="mx-auto max-w-3xl px-5 sm:px-8">
          <p className="eyebrow text-terra-ink">Rechtliches</p>
          <h1 className="mt-5 font-display text-[2.1rem] font-bold uppercase leading-[0.9] sm:text-7xl">{meta.title}</h1>
          <div className="mt-10">{type === "impressum" ? <Impressum /> : <Datenschutz />}</div>
        </article>
      </main>
      <Footer onCookies={onCookies} />
    </>
  );
}
